import axiosInstance from "../../utils/axiosInstance";

const faqService = {

    getList: async (page = 1, pageSize = 10, search = "") => {

        const response = await axiosInstance.get("/Faq", {
            params: {
                page,
                pageSize,
                search
            }
        });

        return response.data;
    },


    getById: async (id) => {

        const response = await axiosInstance.get(
            `/Faq/${id}`
        );

        return response.data;
    },


    create: async (data) => {

        const response = await axiosInstance.post(
            "/Faq",
            data
        );

        return response.data;
    },


    update: async (id, data) => {

        const response = await axiosInstance.put(
            `/Faq/${id}`,
            data
        );

        return response.data;
    },


    delete: async (id) => {

        const response = await axiosInstance.delete(
            `/Faq/${id}`
        );

        return response.data;
    }

};

export default faqService;